<!-- TODO: add loading state if slots will be received in separate way -->
<!--       now they're part of external logic -->
<!--@if (loading()) {-->
<!--  <div class="flex w-full items-center justify-center py-4">-->
<!--    <shared-loader></shared-loader>-->
<!--  </div>-->
<!--} @else if (hasSlots()) {-->
<div class="mb-2 grid grid-cols-7 gap-2">
  @for (uiDay of uiDays(); track uiDay.date) {
    <button
      type="button"
      class="flex min-h-16 flex-col items-center justify-center gap-0.5 rounded-lg p-2"
      [class.hover:border-primary-300]="uiDay.available"
      [class.cursor-pointer]="uiDay.available"
      [ngClass]="getUiDayClasses(uiDay)"
      [disabled]="!uiDay.available"
      (click)="selectUiDay(uiDay)"
    >
      <div class="font-semibold uppercase">
        {{ formatSlotDay(uiDay.date) }}
      </div>
      <div class="text-sm opacity-75">
        {{ formatSlotDate(uiDay.date) }}
      </div>
    </button>
  }
</div>
<!--}-->
